import ListView from "./ListView/ListView";

const HistoryTraksi = () => <p>HistoryTraksi</p>;

HistoryTraksi.ListView = ListView;
export default HistoryTraksi;
